"use client";

import { CalendarDays, Clock3, ArrowLeft } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";

export default function BlogHero({ blog }: any) {
  return (
    <section className="relative w-full h-screen overflow-hidden">

      {/* Back link removed from corner; moved to overlay category badge below */}

      {/* Background Image */}
   {/* Background Image */}
  <Image
  src={blog.coverImage}
  alt={blog.title}
  fill
  priority
  className="object-cover"
/>

  {/* Emerald overlay */}
<div className="absolute inset-0 z-[5] bg-gradient-to-r from-emerald-950/90 via-emerald-900/70 to-transparent"></div>
      {/* Hero Content */}
      <div className="relative z-20 max-w-6xl mx-auto px-6 h-full flex flex-col justify-center">

        {/* Category Badge with back button above it */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex flex-col items-start">
            <Link
              href="/blogs"
              aria-label="Back to blogs"
              className="mb-3 inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full backdrop-blur-sm text-base"
            >
              <ArrowLeft size={18} />
              <span className="font-medium">Back to All Blogs</span>
            </Link>

            <span className="inline-block bg-emerald-600/90 backdrop-blur px-5 py-2 rounded-full text-sm font-semibold text-white">
              {blog.category}
            </span>
          </div>
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mt-6 text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight max-w-4xl"
        >
          {blog.title}
        </motion.h1>

        {/* Excerpt */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mt-6 text-lg text-gray-200 max-w-2xl leading-relaxed"
        >
          {blog.excerpt}
        </motion.p>

        {/* Meta Info */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="flex flex-wrap items-center gap-6 mt-8 text-sm text-gray-200"
        >
          <span className="font-medium">{blog.author}</span>

          <span className="flex items-center gap-2">
            <CalendarDays size={16} />
            {blog.date}
          </span>

          <span className="flex items-center gap-2">
            <Clock3 size={16} />
            {blog.readTime}
          </span>
        </motion.div>
      </div>

      {/* Bottom fade for transition */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-gray-50 to-transparent" />
    </section>
  );
}